const initialState = {
  resultsAccountsList: [],
  resultsAccountsListFiltered: [],
  resultsAccount: {},
  resultsAccountAdd: {},
  resultsAccountEdit: {},
  resultsAccountAddressAdd: {},
  resultsAccountAddressEdit: {},
  resultsAccountBank: {},
  resultsAccountBankAdd: {},
  resultsAccountBankEdit: {},
  resultsAccountImages: {},
  resultsAccountImageAdd: {},
  resultsAccountImageEdit: {},
  resultsAccountUsers: [],
  resultsAccountUsersAdd: [],
  resultsAccountUsersDelete: {},
  resultsAccountEditProperty: {},
  resultsAccountImageDelete: {}
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_ACCOUNT_RESPONSE_GET":
      newState.resultsAccountsList = action.value;
      break;
    case "LIST_ACCOUNT_FILTERED_RESPONSE_GET":
      newState.resultsAccountsListFiltered = action.value;
      break;
    case "ACCOUNT_RESPONSE_GET":
      newState.resultsAccount = action.value;
      break;
    case "ACCOUNT_RESPONSE_RESET":
      newState.resultsAccount = {};
      newState.resultsAccountAddressAdd = {};
      newState.resultsAccountAddressEdit = {};
      newState.resultsAccountBankAdd = {};
      newState.resultsAccountBankEdit = {};
      break;
    case "ACCOUNT_RESPONSE_ADD":
      newState.resultsAccountAdd = action.value;
      break;
    case "ACCOUNT_RESPONSE_EDIT":
      newState.resultsAccountEdit = action.value;
      break;
    case "ACCOUNT_ADDRESS_RESPONSE_ADD":
      newState.resultsAccountAddressAdd = action.value;
      break;
    case "ACCOUNT_ADDRESS_RESPONSE_EDIT":
      newState.resultsAccountAddressEdit = action.value;
      break;
    case "ACCOUNT_BANK_RESPONSE_GET":
      newState.resultsAccountBank = action.value;
      break;
    case "ACCOUNT_BANK_RESPONSE_ADD":
      newState.resultsAccountBankAdd = action.value;
      break;
    case "ACCOUNT_BANK_RESPONSE_EDIT":
      newState.resultsAccountBankEdit = action.value;
      break;
    case "ACCOUNT_IMAGE_RESPONSE_GET":
      newState.resultsAccountImages = action.value;
      break;
    case "ACCOUNT_IMAGE_RESPONSE_ADD":
      newState.resultsAccountImageAdd = action.value;
      break;
    case "ACCOUNT_IMAGE_RESPONSE_DELETE":
      newState.resultsAccountImageDelete = action.value;
      break;
    case "ACCOUNT_IMAGE_RESPONSE_EDIT":
      newState.resultsAccountImageEdit = action.value;
      break;
    case "ACCOUNT_USERS_RESPONSE_GET":
      newState.resultsAccountUsers = action.value;
      break;
    case "ACCOUNT_USERS_RESPONSE_ADD":
      newState.resultsAccountUsersAdd = action.value;
      break;
    case "ACCOUNT_USERS_RESPONSE_DELETE":
      newState.resultsAccountUsersDelete = action.value;
      break;
    case "ACCOUNT_RESPONSE_PROPERTY_EDIT":
      newState.resultsAccountEditProperty = action.value;
      break;
    case "RESET_ACCOUNT_RESPONSES":
      newState.resultsAccountAdd = {};
      newState.resultsAccountEdit = {};
      newState.resultsAccountEditProperty = {}
      break;
    case "RESET_ACCOUNTLIST_RESPONSES":
      newState.resultsAccountsList = [];
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;
